var $ = jQuery.noConflict();
var marqueetop = true;



window.onload = function() {
    //$(this).scrollTop(0); 
};

/*


window.onbeforeunload = function () {
  window.scrollTo(0, 0);
}


// Force page to load at top on refresh/back
if ('scrollRestoration' in history) {
  history.scrollRestoration = 'manual';
}

window.addEventListener('DOMContentLoaded', function () {
  window.scrollTo(0, 0);
});
*/

$(function(){

     //$(this).scrollTop(0); 

  

    $('.product-block-collections a').on('click', function(e) {
        // Prevent default link navigation (href is for SEO crawlability only)
        e.preventDefault();
        
        // Check if hide_mobile_dropdown is enabled
        var $productBlockCollections = $(this).closest('.product-block-collections');
        var hideMobileDropdown = $productBlockCollections.attr('data-hide-mobile-dropdown') !== undefined;
        
        // Handle on desktop (> 820px) OR when hide_mobile_dropdown is enabled (keep desktop behavior on mobile)
        if ($(window).width() > 820 || hideMobileDropdown) {
            var collectionValue = $(this).data('collection');

            // Get current active collection
            var currentActive = $('.product-block-wrapper2.active');
            if (currentActive.length) {
                //destroyProductBlockSlider(currentActive.find('.products-carousel'));
            }

            // Remove active class from all
            $('.product-block-collections a').removeClass('active');
            $('.product-block-wrapper2').removeClass('active');

            // Add active to clicked link
            $(this).addClass('active');

            // Find and add active to matching wrapper
            var newActiveWrapper = $('.product-block-wrapper2[data-collection="' + collectionValue + '"]');
            newActiveWrapper.addClass('active');

            // Initialize slider for the new active wrapper
            //initProductBlockSlider(newActiveWrapper.find('.products-carousel'));
        }
    });

    // Initialize the first active product block slider on page load
    var firstActiveWrapper = $('.product-block-wrapper2.active');
    if (firstActiveWrapper.length) {
        //initProductBlockSlider(firstActiveWrapper.find('.products-carousel'));
    }



    $('.fdp-current-country').on('click', function() {
        const $parent = $(this).parent(); // Store the parent element in a variable
        $parent.toggleClass('active');
    
        setTimeout(() => {
            $parent.toggleClass('animation-active'); // Use the stored parent element
        }, 50);
    });


      // Collection Image Visibility Setup
      function setupCollectionImageVisibility() {
        // For scroll-based visibility
        const menuItems = document.querySelectorAll('.menu-lv-3-collection-image');
        
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('is-visible');
                }
            });
        }, {
            threshold: 0.1
        });

        menuItems.forEach(item => {
            observer.observe(item);
        });

        // Set sidebar height and handle first item visibility
        $('.menu-lv-1.has-megamenu.costumes-menu-item .menu-dropdown .menu-dropdown__column').each(function() {
            // Add is-visible to first .site-nav-sub-collection-image1
            $(this).find('.site-nav-sub-collection-image').first().addClass('is-visible');

            // Set sidebar height for each .site-nav-sub
           /* $(this).find('.site-nav-sub').each(function() {
                const sidebarHeight = $(this).outerHeight();
                $(this).attr('style', '--sidebar-height: ' + sidebarHeight + 'px');
            });*/
        });

        // For hover and click-based visibility
        $('.menu-lv-1.has-megamenu.costumes-menu-item .menu-dropdown .site-nav.dropdown > .site-nav-list > a').each(function() {
            const $link = $(this);
            const $parentItem = $link.closest('.site-nav-sub-collection-image1');
            const $allItems = $parentItem.parent().find('.site-nav-sub-collection-image1');
            const $menuItem = $link.closest('.menu-lv-1[data-preload-images="true"]');
            const enablePreloading = $menuItem.length > 0;

            // Handle hover
            $link.on('mouseenter', function() {
                $allItems.removeClass('is-visible');
                $parentItem.addClass('is-visible');
                // Preload images if enabled
                if (enablePreloading) {
                    sg9PreloadLevel3CollectionImages($link.closest('.site-nav.dropdown'));
                }
            });

            // Handle click for mobile
            $link.on('click', function(e) {
                if (!$parentItem.hasClass('is-visible')) {
                    e.preventDefault();
                    $allItems.removeClass('is-visible');
                    $parentItem.addClass('is-visible');
                    // Preload images if enabled
                    if (enablePreloading) {
                        sg9PreloadLevel3CollectionImages($link.closest('.site-nav.dropdown'));
                    }
                }
            });
        });

        // Reset visibility when menu closes
        $('.menu-lv-1.has-megamenu.costumes-menu-item').on('mouseleave', function() {
            const $column = $(this).find('.menu-dropdown__column');
            const $items = $column.find('.site-nav-sub-collection-image1');
            $items.removeClass('is-visible');
            $items.first().addClass('is-visible');
        });

        // Update sidebar height on window resize
        /*$(window).on('resize', function() {
            $('.menu-lv-1__action[href*="/collections/costumes"] ~ .menu-dropdown .site-nav.dropdown.is-visible > .site-nav-list > a + div.site-nav-sub').each(function() {
                const sidebarHeight = $(this).outerHeight();
                $(this).attr('style', '--sidebar-height: ' + sidebarHeight + 'px');
            });*/
    }

    // Initialize collection image visibility
    setupCollectionImageVisibility();
  

    


    $fdpMainSldier = $('.custom-slideshow-wrapper .custom-slideshow');

    $fdpMainSldier.on('init', function(event, slick, direction){

        //$('.slick-active').addClass('first-slide');        

        setTimeout(function() {
             $('.slick-active').addClass('animation-active2');           
          }, 5); 

        setTimeout(function() {
           /* 
            if ( $('.slick-active').hasClass('first-slide')  ) {

            } else {
                $('.slick-active').addClass('animation-active');           
            }
*/
            $('.slick-active').addClass('animation-active');           

        }, 125); 

     //console.log('init1')
        

    })

    $fdpMainSldier.each(function () {
        var self = $(this),
            dataArrows = self.data('arrows'),
            dataDots = self.data('dots'),
            autoplay = self.data('autoplay'),
            autoplaySpeed = self.data('autoplay-speed')
  


            self.slick({
        dots: true,
        //infinite: true,
        autoplay: self.data('autoplay'),
        autoplaySpeed: self.data('autoplay-speed'),
        //arrows: self.data('arrows'),
        speed: 500,
        slidesToShow: 1,
        pauseOnHover: true,
        nextArrow: window.arrows.icon_next,
        prevArrow: window.arrows.icon_prev,
        responsive: [
            {
              breakpoint: 820,
              settings: {
                arrows: false,
                dots: true
              }
            }
          ]
        });



      $fdpMainSldier.on('swipe', function(event, slick, direction){
        //console.log(direction);
        // left
        });

        // On edge hit
        $fdpMainSldier.on('edge', function(event, slick, direction){
        //console.log('edge was hit')
        });

        // On before slide change
        $fdpMainSldier.on('beforeChange', function(event, slick, currentSlide, nextSlide){

          //  console.log('beforeChange/init', event, slick, slick.$slides);

           // console.log(nextSlide);
           // console.log( $(this) );
           
          
            
        });

        $fdpMainSldier.on('afterChange init', function(event, slick, direction){
            //console.log('afterChange/init', event, slick, slick.$slides);
            // remove all prev/next
            //slick.$slides.removeClass('prevdiv').removeClass('nextdiv');

            // find current slide
            for (var i = 0; i < slick.$slides.length; i++)
            {
                var $slide = $(slick.$slides[i]);
                if ($slide.hasClass('slick-current')) {
                    // update DOM siblings
                    //$slide.prev().addClass('prevdiv');
                    $slide.prev().addClass('load-images');
                    $slide.next().addClass('load-images');

                    $slide.addClass('load-images');
                    //$('.slick-slide').removeClass('first-slide');
                    $('.item > div').removeClass('first-slide');

                    break;
                }
            }

            setTimeout(function() {
            
                $('.slick-active').addClass('animation-active2');           

            }, 5); 


            setTimeout(function() {
            
                $('.slick-active').addClass('animation-active');           

            }, 125); 

             
        }); // $fdpMainSldier

        

    $fdpMainSldier.on('beforeChange', function(event, slick) {
        $('.slick-slide').removeClass('animation-active');  
        $('.slick-slide').removeClass('animation-active2');  
    })


});



    //$('.rbr-mbap_item_info .pl-swatches-collection').remove();
    
	
    // Add fixed-header class
	if ( ! $('body').hasClass('checkout') ) {
	 
		/* Sticky menu	*/
		var $document3 = $(document),
			$element3 = $('body'),
			className3 = 'fixed-header',
			scrollThreshold = $(window).width() <= 1024 ? 32 : 36;

		$document3.scroll(function() {
		  //$element3.toggleClass(className3, $document3.scrollTop() >= 240);	  
		  $element3.toggleClass(className3, $document3.scrollTop() >= scrollThreshold);	  
		});	
		
		// Update threshold on window resize
		$(window).on('resize', function() {
		  scrollThreshold = $(window).width() <= 1024 ? 32 : 36;
		});
			
	}

    
      // Load Category Icons in Menu - on mouseover
	$('.menu-lv-1.has-megamenu.dropdown').on('mouseover', function() {
		$(this).addClass('menu-icons-active');
	});

    // Function to handle collection image loading on menu hover
    function sg9LoadCollectionImagesOnHover() {
        if ($('.menu-lv-1.has-megamenu.dropdown').length > 0) {
            $('.menu-lv-1.has-megamenu.dropdown').on('mouseover', function() {
                // Find all collection images and change data-src to src for lazy loading
                $(this).find('.collection-image img').each(function() {
                    var $img = $(this);
                    var dataSrc = $img.attr('data-src');
                    if (dataSrc && !$img.attr('src')) {
                        $img.attr('src', dataSrc);
                    }
                });
            });
        }
    }

    // Function to preload collection images in submenu on hover/click
    function sg9PreloadLevel3CollectionImages($element) {
        // Find all collection images in the submenu and preload them
        $element.find('.menu-collection-image img').each(function() {
            var $img = $(this);
            var dataSrc = $img.attr('data-srcset') || $img.attr('data-src');
            if (dataSrc && !$img.attr('src') && !$img.attr('srcset')) {
                if ($img.attr('data-srcset')) {
                    $img.attr('srcset', dataSrc);
                } else {
                    $img.attr('src', dataSrc);
                }
            }
        });
    }

    // Initialize the function
    sg9LoadCollectionImagesOnHover();



    function sg9ClickableDropdownMenuDesktop() {

        var documentWidth = $(document).width();

        //console.log('sg9ClickableDropdownMenuDesktop called, width:', documentWidth);
        //console.log('Found .menu-lv-1__action elements:', $('.menu-lv-1__action').length);

        if (documentWidth > 1024) {



            // Touch Screen Menu Level 1 Dropdown
            $('.menu-lv-1.has-megamenu.dropdown > span[aria-label="Drop Down Menu"]').on('click', function() {

                if ( $(this).hasClass('menu-dropdown-active')  ) {
                    $('span[aria-label="Drop Down Menu"]').removeClass('menu-dropdown-active');
                    $(this).removeClass('menu-dropdown-active');
                    //$(this).closest('.menu-lv-1').removeClass('menu-dropdown-active');

                } else {

                    $('span[aria-label="Drop Down Menu"]').removeClass('menu-dropdown-active');

                    $(this).addClass('menu-dropdown-active');
                    $(this).closest('.menu-lv-1').addClass('menu-icons-active');

                }

            });

              // Touch Screen Menu Level 1 Dropdown
              $('.menu-lv-1.has-megamenu.dropdown').on('mouseover', function() {

                $('span[aria-label="Drop Down Menu"]').removeClass('menu-dropdown-active');
                //$('.menu-lv-1').removeClass('menu-dropdown-active');

            });

            // Add hover functionality for .menu-lv-1__action with event delegation
            $(document).on('mouseenter', '.menu-lv-1__action', function() {
                //('Hovering over menu-lv-1__action');
                const $dropdownSpan = $(this).closest('.menu-lv-1').find('span[aria-label="Drop Down Menu"]');
                //console.log('Found dropdown span:', $dropdownSpan.length);
                $dropdownSpan.addClass('menu-dropdown-active');
            });

            $(document).on('mouseleave', '.menu-lv-1__action', function() {
                //console.log('Leaving hover on menu-lv-1__action');
                const $dropdownSpan = $(this).closest('.menu-lv-1').find('span[aria-label="Drop Down Menu"]');
                $dropdownSpan.removeClass('menu-dropdown-active');
            });

            // Also try direct binding as fallback
            $('.menu-lv-1__action').hover(
                function() {
                    //console.log('Direct hover: entering');
                    $(this).closest('.menu-lv-1').find('span[aria-label="Drop Down Menu"]').addClass('menu-dropdown-active');
                },
                function() {
                    //console.log('Direct hover: leaving');
                    $(this).closest('.menu-lv-1').find('span[aria-label="Drop Down Menu"]').removeClass('menu-dropdown-active');
                }
            );

        } else {

            $('span[aria-label="Drop Down Menu"]').removeClass('menu-dropdown-active');
           //$('.menu-lv-1').removeClass('menu-dropdown-active');

        }



    }; // sg9ClickableDropdownMenuDesktop()

sg9ClickableDropdownMenuDesktop(); 


    // Function to toggle product block collections dropdown based on window width
    function sgProductBlockCollectionsDropdown() {
        var windowWidth = $(window).width();
        var $productBlockCollections = $('.product-block-collections');
        var $wrapper = $productBlockCollections.find('> div');
        
        // Check if hide_mobile_dropdown is enabled and there are collection links (data available)
        var hideMobileDropdown = $productBlockCollections.attr('data-hide-mobile-dropdown') !== undefined;
        var hasCollectionData = $wrapper.find('a[data-collection]').length > 0;
        
        // If hide_mobile_dropdown is true and data is available, skip dropdown behavior (keep desktop way)
        if (hideMobileDropdown && hasCollectionData) {
            // Remove dropdown class and any wrapper elements if they exist
            $productBlockCollections.removeClass('product-block-collections-dropdown');
            
            if ($wrapper.find('.product-block-collections-wrapper').length) {
                var $innerDiv = $wrapper.find('.product-block-collections-wrapper > div');
                $wrapper.append($innerDiv.contents());
                $wrapper.find('.product-block-collections-wrapper').remove();
            }
            $wrapper.removeClass('collections-expanded');
            $productBlockCollections.find('.product-block-collections-wrapper').removeClass('collections-expanded');
            return; // Exit early, keeping desktop behavior
        }
        
        if (windowWidth <= 820) {
            $productBlockCollections.addClass('product-block-collections-dropdown');
            
            // Wrap the collection links similar to swatches pattern
            if (!$wrapper.find('.product-block-collections-wrapper').length) {
                // Always use "Select a category" as initial placeholder
                var buttonText = 'Select a category';
                
                // First wrap content in wrapper with inner div
                $wrapper.wrapInner('<div class="product-block-collections-wrapper"><div></div></div>')
                    .find('.product-block-collections-wrapper').prepend('<a href="#" class="pbc-toggle-button">' + buttonText + '</a>')
                    .append('<span class="collections-dropdown"><span></span></span>');
                
                // Add arrow-icons class if more than one collection
                if ($wrapper.find('a').length > 1) {
                    $wrapper.find('.product-block-collections-wrapper').addClass('arrow-icons');
                }
            }
            
            // Attach click handler for dropdown toggle and collection change
            $(document).off('click.pbcDropdown', '.product-block-collections .pbc-toggle-button, .product-block-collections a.button')
                .on('click.pbcDropdown', '.product-block-collections .pbc-toggle-button, .product-block-collections a.button', function(e){
                    // Prevent default for all clicks (href="#" or collection links)
                    e.preventDefault();
                    
                    var $link = $(this);
                    var collectionValue = $link.data('collection');
                    
                    // If it's a button with data-collection, change the collection
                    if ($link.hasClass('button') && collectionValue) {

                        // If clicking the active button, toggle dropdown to see more items
                        if ($link.hasClass('active')) {
                            $link.closest('.product-block-collections-wrapper').toggleClass('collections-expanded');
                            $link.closest('.product-block-collections > div').toggleClass('collections-expanded');
                        } else {
                            // Remove active class from all
                            $('.product-block-collections a').removeClass('active');
                            $('.product-block-wrapper2').removeClass('active');

                            // Add active to clicked link
                            $link.addClass('active');

                            // Find and add active to matching wrapper
                            var newActiveWrapper = $('.product-block-wrapper2[data-collection="' + collectionValue + '"]');
                            newActiveWrapper.addClass('active');

                            // Hide toggle button after first selection
                            var $toggleButton = $link.closest('.product-block-collections-wrapper').find('.pbc-toggle-button');
                            $toggleButton.hide();

                            // Scroll to top of the inner div before closing dropdown
                            $('div.collections-expanded .product-block-collections-wrapper > div').scrollTop(0);

                            // Close dropdown after selection
                            $('.product-block-collections > div').removeClass('collections-expanded');
                            $link.closest('.product-block-collections-wrapper').removeClass('collections-expanded');
                        }
                    } else {
                        // Toggle dropdown for regular links (toggle button)
                        var $wrapper = $link.closest('.product-block-collections-wrapper');
                        var $parent = $link.closest('.product-block-collections > div');
                        var wasExpanded = $parent.hasClass('collections-expanded');
                        
                        $wrapper.toggleClass('collections-expanded');        
                        $parent.toggleClass('collections-expanded');
                        
                        // Hide toggle button when transitioning from closed to open
                        if (!wasExpanded && $parent.hasClass('collections-expanded')) {
                            $link.hide();
                        }
                    }
                });
            
        } else {
            $productBlockCollections.removeClass('product-block-collections-dropdown');
            
            // Remove wrapper on desktop view
            if ($wrapper.find('.product-block-collections-wrapper').length) {
                // Find the inner div containing the original content
                var $innerDiv = $wrapper.find('.product-block-collections-wrapper > div');
                // Move the original content back to $wrapper
                $wrapper.append($innerDiv.contents());
                // Remove the entire wrapper
                $wrapper.find('.product-block-collections-wrapper').remove();
            }
            $wrapper.removeClass('collections-expanded');
            $productBlockCollections.find('.product-block-collections-wrapper').removeClass('collections-expanded');
        }
    }

    // Initialize product block collections dropdown
    sgProductBlockCollectionsDropdown();

    // Delayed initialization to ensure menu elements are loaded
    setTimeout(function() {
        //console.log('Delayed initialization - checking for menu elements again');
        //console.log('Found .menu-lv-1__action elements after delay:', $('.menu-lv-1__action').length);
        sg9ClickableDropdownMenuDesktop();
    }, 1000);


 

    // Run Scripts after Window Resize
	/*! run scirpt after resize by Dolan Antenucci https://stackoverflow.com/users/318870/dolan-antenucci-   - https://stackoverflow.com/posts/5926068/revisions https://stackoverflow.com/questions/5489946/jquery-how-to-wait-for-the-end-of-resize-event-and-only-then-perform-an-ac/5926068#5926068 */
	var rtime;
	var timeout = false;
	var delta = 100;
	$(window).resize(function() {
		rtime = new Date();
		if (timeout === false) {
			timeout = true;
			setTimeout(resizeend, delta);
		}
	});

	function resizeend() {

	   if (new Date() - rtime < delta) {
			setTimeout(resizeend, delta);
		} else {
			timeout = false;

            sg9ClickableDropdownMenuDesktop();

           // sg9ExpandProductSpecifications();
            
            initShowMoreButton();
            
            // sgFixedFilter and sgFixedFilterMobile are handled in sg-functions-fixed-filters.js

            sgProductBlockCollectionsDropdown();
 			
 			// Manage animated promo on resize
 			manageAnimatedPromo();
            //sgAddMenuItem();

		}

	} // resizeend()



    $('.halo-product-block[data-simple-product-card="slider-simple-product-card"] .pl-swatches-collection').remove();
    $('.halo-product-block[data-simple-product-card="slider-simple-product-card"] .card-action').remove();
        



    
    // Animated promo code toggling
    var animatedPromoInterval = null;
    var originalPromoContent = null;

    function toggleAnimatedPromo() {
        if ($('.promo-code-animated').length) {
            if (marqueetop) {
                // marquee logic
                var $container = $('.marquee-container');
                if ($container.length) {
                    //$container.animate({scrollLeft: '+=200'}, 3000);
                }
            } else {
                //console.log('toggleAnimatedPromo firing');
                var $promo = $('.promo-code-animated');
                var $divs = $promo.find('> div');
                //console.log('divs length: ', $divs.length);
                if ($divs.length >= 2) {
                    var $visible = $divs.not(':hidden').first();
                    var $next = $visible.next().length ? $visible.next() : $divs.first();

                    $visible.fadeOut(500, function() {
                        $next.fadeIn(500);
                    });
                }
            }
        }
    }

    function manageAnimatedPromo() {
        var hasAnimatedPromo = $('.promo-code-animated').length;
        var promoWidth = parseInt($('.promo-box-wrapper').data('promo-box-animated')) || 500;
        var isMobile = $(window).width() < promoWidth;

        if (hasAnimatedPromo && isMobile) {
            if (marqueetop) {
                // set up CSS marquee animation
                var $promoWrapper = $('.promo-box-wrapper');
                $promoWrapper.addClass('promo-marquee');
                if (!$promoWrapper.hasClass('marquee-setup') && !$promoWrapper.find('.promo-marquee-row').length) {
                    originalPromoContent = $promoWrapper.html();
                    var $row = $('<div class="promo-marquee-row"></div>');
                    var $items = $promoWrapper.find('.announcement-bar__item-scroll');
                    for (var i = 0; i < 5; i++) { // clone 5 times
                        $items.each(function() {
                            $row.append($(this).clone());
                        });
                    }
                    $promoWrapper.empty().append($row);
                    $promoWrapper.addClass('marquee-setup');
                }
            } else {
                if (animatedPromoInterval === null) {
                    // Initialize by showing the first div and hiding others
                    $('.promo-code-animated > div').hide();
                    $('.promo-code-animated > div').first().show();

                    // Start toggling every 3 seconds
                    animatedPromoInterval = setInterval(toggleAnimatedPromo, 4000);
                }
            }
        } else {
            if (animatedPromoInterval !== null) {
                clearInterval(animatedPromoInterval);
                animatedPromoInterval = null;
                // Optionally, reset to show first or all
                $('.promo-code-animated > div').show(); // Show all or reset as needed
                $('.promo-code-animated > div').removeAttr( 'style' );
            }
            // for marquee, stop animation and restore original content
            if (marqueetop && originalPromoContent !== null) {
                var $promoWrapper = $('.promo-box-wrapper');
                $promoWrapper.removeClass('promo-marquee marquee-setup');
                $promoWrapper.empty().html(originalPromoContent);
                originalPromoContent = null;
            }
        }

        //console.log('after rezide managed')
    }

    // Initialize on load
    manageAnimatedPromo();


    $('.custom-featured-photo').viewportChecker({    
        offset: -750,
        callbackFunction: function(elem, action){
            var $videoLoad = $(elem).find('.video-load');
            if ($videoLoad.length > 0 && $videoLoad.find('video').length === 0) {
                var $dataVideoId = $(elem).attr('data-video');
                if ($dataVideoId) {
                    $videoLoad.append('<video autoplay="" loop="" muted="" playsinline=""><source id="mp4" src="' + $dataVideoId +'" type="video/mp4"></video>');
                }
            }
        }
    });
   

    $('.wrapper-footer').viewportChecker({    
        offset: -750        
    });
   






    //$('nav.header__inline-menu > ul > li:nth-child(6)').after('<li class="menu-lv-item menu-lv-1 has-megamenu dropdown block_layout--custom_width"><a href="/collections/halloween" class="menu-lv-1__action header__menu-item header__menu-item list-menu__item link link--text focus-inset"><span class="text link-effect">Halloween</span></a></li>');

/*
// Select the div
let triggerDiv = $('#block-image_7DixBd');
// Select the div


// Function to simulate hover (mouseenter and mouseleave)
function triggerHover() {
    triggerDiv.addClass('hover-active'); // Simulate mouse enter (hover)

    console.log("triggerHover add");

    setTimeout(function() {
        triggerDiv.removeClass('hover-active'); // Simulate mouse leave after a short time

        console.log("triggerHover remove");

    //}, 2500); // Adjust time (500 ms) for how long the hover effect should last
    }, 2500); // Adjust time (500 ms) for how long the hover effect should last


}

// Start triggering hover every 2 seconds
//let intervalId = setInterval(triggerHover, 5000);
let intervalId = setInterval(triggerHover, 5000);

// Stop triggering after 10 seconds (or any desired time)
setTimeout(function() {
    //clearInterval(intervalId);
}, 25000);
*/


// Select the div
/*
if ($('#block-image_7DixBd').length) {
    
    let triggerDiv = $('#block-image_7DixBd');

    // Declare variables to store intervals and timeouts
    let intervalId;
    let hoverTimeout;

    // Function to simulate hover (mouseenter and mouseleave)
    function triggerHover() {
        triggerDiv.addClass('hover-active'); // Simulate mouse enter (hover)
        //console.log("triggerHover add");

        setTimeout(function() {
            triggerDiv.removeClass('hover-active'); // Simulate mouse leave after a short time
            //console.log("triggerHover remove");
        }, 2500); // Adjust time (2500 ms) for how long the hover effect should last
    }

    // Start triggering hover every 5 seconds
    intervalId = setInterval(triggerHover, 5000);

    // Stop hover simulation on actual hover
    triggerDiv.on('mouseenter', function() {
        clearInterval(intervalId); // Pause the hover simulation
        clearTimeout(hoverTimeout); // Clear any scheduled re-trigger
        triggerDiv.removeClass('hover-active'); // Clear 'hover-active' class immediately
        //console.log("Mouse entered, hover simulation paused");
    });

    // Resume hover simulation on mouse leave
    triggerDiv.on('mouseleave', function() {
        //console.log("Mouse left, scheduling hover simulation to resume");

        // Schedule hover simulation to resume after 2 seconds (or any desired time)
        hoverTimeout = setTimeout(function() {
            intervalId = setInterval(triggerHover, 5000); // Restart hover simulation
            //console.log("Hover simulation resumed");
        },  500);
    });

    // Stop triggering after 25 seconds (optional)
    setTimeout(function() {
        //clearInterval(intervalId); // Stop triggering hover
        //console.log("Hover simulation stopped after 25 seconds");
    }, 25000);

}
*/




/*
function sgFormatPrice() {

    setTimeout(() => {
        // Function to format price
        function formatPrice(price) {
            return `$${(price / 100).toFixed(2)}`;
        }

        // Iterate over each list item
        $('.previewCartItem').each(function() {
            // Get the data-price value
            const priceValue = $(this).find('.previewCartItem-price').data('price');
            if (priceValue) {
                // Format the price
                const formattedPrice = formatPrice(priceValue);

                // Output the result in the console
                console.log(`Formatted Price for Item: ${formattedPrice}`);

                // Update the text inside the .money element for the current item
                $(this).find('.previewCartItem-price .discounted-price .money').text(formattedPrice);
            }
        });
    }, 500);
    
}

// Initial run on page load
sgFormatPrice();

// Attach click event to #cart-icon-bubble
$('#cart-icon-bubble').on('click', function() {
    sgFormatPrice();
});

*/



    // Function to initialize Show More Button functionality for collection lists
    function initShowMoreButton() {
        var viewportWidth = $(window).width();

        $('.custom-collection-list.has-show-more').each(function() {
            var $block = $(this);
            var $items = $block.find('.subcat-grid-item:not(.show-more-button)');
            var $button = $block.find('.fdp-show-more-btn');

            // Note: this script currently uses viewport-based maxItems (not the section setting).
            var maxItems;
            if (viewportWidth <= 410) { 
                maxItems = 8;
            } else if (viewportWidth <= 480) {
                maxItems = 11;
            } else if (viewportWidth <= 580) {
                maxItems = 7;
            } else if (viewportWidth <= 767) {
                maxItems = 9;
            } else if (viewportWidth <= 850) {
                maxItems = 11;
            } else if (viewportWidth <= 960) {
                maxItems = 13;
            } else if (viewportWidth <= 1070) {
                maxItems = 15;
            } else if (viewportWidth <= 1280) {
                maxItems = 17;
            } else if (viewportWidth <= 1380) {
                maxItems = 19;
            } else if (viewportWidth <= 1430) {
                maxItems = 21;
            } else {
                maxItems = 23;
            }

            // Reset: show all items that should be visible at this breakpoint
            $items.each(function(index) {
                if (index < maxItems) {
                    $(this).removeClass('hidden-collection-item').removeAttr('aria-hidden').show();
                }
            });

            // If we have more items than maxItems, hide the rest and reset the button
            if ($items.length > maxItems && $button.length) {
                $items.slice(maxItems).each(function() {
                    $(this).addClass('hidden-collection-item').attr('aria-hidden', 'true').hide();
                });

                $button.attr('aria-expanded', 'false');
                $button.find('.subcat-grid-link__title').text($button.data('text-show') || 'Show More');
                $button.removeClass('show-less-state');
            }

            // If width >= 1400, ensure items 19-23 are visible, and only set button to expanded if all items are now visible
            if (viewportWidth > 1430) {
                $items.slice(19, 23).each(function() {
                    $(this).removeClass('hidden-collection-item').removeAttr('aria-hidden').show();
                });

                var $hiddenItemsAfter = $block.find('.hidden-collection-item:not(.show-more-button)');
                if ($hiddenItemsAfter.length === 0) {
                    $button.attr('aria-expanded', 'true');
                    $button.find('.subcat-grid-link__title').text($button.data('text-hide') || 'Show Less');
                    $button.addClass('show-less-state');
                } else {
                    $button.attr('aria-expanded', 'false');
                    $button.find('.subcat-grid-link__title').text($button.data('text-show') || 'Show More');
                    $button.removeClass('show-less-state');
                }
            }
        });

        // Robust click handler:
        // - Prefer the explicit `data-block` mapping, but fall back to nearest `.custom-collection-list`.
        // - Always toggle based on aria-expanded (visibility checks can be unreliable if CSS changes).
        $(document)
            .off('click.fdpShowMore', '.fdp-show-more-btn')
            .on('click.fdpShowMore', '.fdp-show-more-btn', function(e) {
                e.preventDefault();

                var $button = $(this);
                var blockId = $button.data('block');
                var $block = blockId ? $('#block-' + blockId) : $button.closest('.custom-collection-list');

                if (!$block.length) {
                    console.warn('Show More: could not find block for button', $button.get(0));
                    return;
                }

                var $titleSpan = $button.find('.subcat-grid-link__title');

                var expanded = String($button.attr('aria-expanded')) === 'true';

                if (expanded) {
                    // Collapse: restore hidden items according to current breakpoint
                    $button.attr('aria-expanded', 'false').removeClass('show-less-state');
                    $titleSpan.text($button.data('text-show') || 'Show More');

                    initShowMoreButton();
                } else {
                    // Expand: show all items
                    var $hiddenItems = $block.find('.hidden-collection-item');

                    // IMPORTANT: remove the class as well, otherwise `.hidden-collection-item{display:none}`
                    // could override jQuery `.show()` depending on CSS specificity/order.
                    $hiddenItems.removeAttr('aria-hidden').removeClass('hidden-collection-item').show();

                    $titleSpan.text($button.data('text-hide') || 'Show Less');
                    $button.attr('aria-expanded', 'true').addClass('show-less-state');
                }
            });

        console.log('init initShowMoreButton');
    }

    // Initialize the Show More button functionality (guarded so other script errors don't prevent it)
    try {
        initShowMoreButton();
    } catch (err) {
        console.error('initShowMoreButton failed', err);
    }


 // MutationObserver to watch for changes in .pl-swatches-collection__count_only
    // and replace "colors" with "Styles"
    // Made global so it can be called after AJAX loads
    window.initColorsToStylesObserver = function() {
        // Target all .product-master.product and .fdp-bundle-product-colors elements
        const productMasterElements = document.querySelectorAll('.product-master.product, .fdp-bundle-product-colors');
        
        if (productMasterElements.length === 0) return;
        
        // Helper function to replace colors with Styles
        function replaceColorsWithStyles(element) {
            if (element && element.textContent && element.textContent.toLowerCase().includes('colors')) {
                element.textContent = element.textContent.replace(/colors/gi, 'Styles');
            }
        }
        
        const observer = new MutationObserver((mutationsList) => {
            mutationsList.forEach((mutation) => {
                // Check if mutation target contains or is .pl-swatches-collection__count_only
                if (mutation.type === 'childList' || mutation.type === 'characterData') {
                    const target = mutation.target;
                    
                    // Check if target itself is .pl-swatches-collection__count_only
                    if (target.classList && target.classList.contains('pl-swatches-collection__count_only')) {
                        replaceColorsWithStyles(target);
                    } else if (target.querySelectorAll) {
                        // Find .pl-swatches-collection__count_only within the mutated area
                        target.querySelectorAll('.pl-swatches-collection__count_only').forEach((el) => {
                            replaceColorsWithStyles(el);
                        });
                    }
                    
                    // Also check added nodes
                    if (mutation.addedNodes) {
                        mutation.addedNodes.forEach((node) => {
                            if (node.nodeType === 1) { // Element node
                                if (node.classList && node.classList.contains('pl-swatches-collection__count_only')) {
                                    replaceColorsWithStyles(node);
                                } else if (node.querySelectorAll) {
                                    node.querySelectorAll('.pl-swatches-collection__count_only').forEach((el) => {
                                        replaceColorsWithStyles(el);
                                    });
                                }
                            }
                        });
                    }
                }
            });
        });
        
        // Observe each product-master.product and fdp-bundle-product-colors element
        productMasterElements.forEach((productElement) => {
            observer.observe(productElement, {
                childList: true,
                subtree: true,
                characterData: true
            });
        });
        
        // Also do initial replacement for any existing elements
        document.querySelectorAll('.product-master.product .pl-swatches-collection__count_only, .fdp-bundle-product-colors .pl-swatches-collection__count_only').forEach((el) => {
            replaceColorsWithStyles(el);
        });
    };
    
    // Initialize the observer
    window.initColorsToStylesObserver();



    // Add hover effects for custom-featured elements
    $('.custom-featured-photo a').hover(
        function() {
            $(this).closest('.custom-featured-content-box').addClass('custom-featured-box-hover');
        },
        function() {
            $(this).closest('.custom-featured-content-box').removeClass('custom-featured-box-hover');
        }
    );

    $('a.slide-button.button').hover(
        function() {
            $(this).closest('.custom-featured-content-box').addClass('custom-featured-box-hover');
        },
        function() {
            $(this).closest('.custom-featured-content-box').removeClass('custom-featured-box-hover');
        }
    );

    $('a.custom-featured-link').hover(
        function() {
            $(this).closest('.custom-featured-content-box').addClass('custom-featured-box-hover');
        },
        function() {
            $(this).closest('.custom-featured-content-box').removeClass('custom-featured-box-hover');
        }
    );

}) // document ready
